import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import { Login } from './pages/Login/Login';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { Menu } from './pages/Menu/Menu';
import { Produits } from './pages/Produits/Produits';
import { ProduitDetail } from './pages/Produits/ProduitDetail';
import { ProduitCreate } from './pages/Produits/ProduitCreate';
import { Inventaire } from './pages/Inventaire/Inventaire';
import { Categories } from './pages/Categories/Categories';
import { Regles } from './pages/Regles/Regles';
import { Comptes } from './pages/Comptes/Comptes';
import { Commandes } from './pages/Commandes/Commandes';
import { CommandeDetailPage } from './pages/Commandes/CommandeDetail';
import { Reductions } from './pages/Reductions/Reductions';
import { ImportFacture } from './pages/ImportFacture/ImportFacture';
import { Statistiques } from './pages/Statistiques/Statistiques';
import { Recettes } from './pages/Recettes/Recettes';
import { Avis } from './pages/Avis/Avis';
import { Banners } from './pages/Banners/Banners';
import { Ventes } from './pages/Ventes/Ventes';
import { EnrichisseurFournisseur } from './pages/Produits/EnrichisseurFournisseur';
import './App.css';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/menu"      element={<ProtectedRoute><Menu /></ProtectedRoute>} />
          <Route path="/produits"          element={<ProtectedRoute><Produits /></ProtectedRoute>} />
          <Route path="/produits/nouveau"  element={<ProtectedRoute><ProduitCreate /></ProtectedRoute>} />
          <Route path="/produits/enrichir" element={<ProtectedRoute><EnrichisseurFournisseur /></ProtectedRoute>} />
          <Route path="/produits/:id"      element={<ProtectedRoute><ProduitDetail /></ProtectedRoute>} />
          <Route path="/inventaire"  element={<ProtectedRoute><Inventaire /></ProtectedRoute>} />
          <Route path="/categories"  element={<ProtectedRoute><Categories /></ProtectedRoute>} />
          <Route path="/regles"      element={<ProtectedRoute><Regles /></ProtectedRoute>} />
          <Route path="/comptes"   element={<ProtectedRoute><Comptes /></ProtectedRoute>} />
          <Route path="/commandes" element={<ProtectedRoute><Commandes /></ProtectedRoute>} />
          <Route path="/commandes/:id" element={<ProtectedRoute><CommandeDetailPage /></ProtectedRoute>} />
          <Route path="/reductions"    element={<ProtectedRoute><Reductions /></ProtectedRoute>} />
          <Route path="/import-facture"  element={<ProtectedRoute><ImportFacture /></ProtectedRoute>} />
          <Route path="/statistiques"   element={<ProtectedRoute><Statistiques /></ProtectedRoute>} />
          <Route path="/recettes"       element={<ProtectedRoute><Recettes /></ProtectedRoute>} />
          <Route path="/avis"           element={<ProtectedRoute><Avis /></ProtectedRoute>} />
          <Route path="/banners"        element={<ProtectedRoute><Banners /></ProtectedRoute>} />
          <Route path="/ventes"         element={<ProtectedRoute><Ventes /></ProtectedRoute>} />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
